import React, { FC }                 from "react";
import Slider                        from "react-slick";
import "slick-carousel/slick/slick.css";
import CarouselCheckHorizontalWidget from "./CarouselCheckHorizontalWidget";
import CarouselCheckVerticalWidget   from "./CarouselCheckVerticalWidget";
import CarouselImageA4Widget         from "./CarouselImageA4Widget";
import CarouselImageLargeWidget      from "./CarouselImageLargeWidget";
import CarouselImageMediumWidget     from "./CarouselImageMediumWidget";
import CarouselImageSmallWidget      from "./CarouselImageSmallWidget";
import CarouselRadioHorizontalWidget from "./CarouselRadioHorizontalWidget";
import CarouselRadioVerticalWidget   from "./CarouselRadioVerticalWidget";
import CarouselTextAreaLargeWidget   from "./CarouselTextAreaLargeWidget";
import CarouselTextAreaMediumWidget  from "./CarouselTextAreaMediumWidget";
import CarouselTextAreaSmallWidget   from "./CarouselTextAreaSmallWidget";
import CarouselTextBoxWidget         from "./CarouselTextBoxWidget";
import "./css/DragWidgetCarousel.scss"
import DragWidget                    from "./layout/DragWidget";

const WidgetCarousel: FC = () => {
  return (
    <>
      <Slider
        speed={ 500 }
        infinite
        slidesToShow={ 4 }
        slidesToScroll={ 4 }
        variableWidth
      >
        <div>
          <DragWidget>
            <CarouselTextBoxWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselTextAreaSmallWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselTextAreaMediumWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselTextAreaLargeWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselRadioVerticalWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselRadioHorizontalWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselCheckVerticalWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselCheckHorizontalWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselImageSmallWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselImageMediumWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselImageLargeWidget/>
          </DragWidget>
        </div>
        <div>
          <DragWidget>
            <CarouselImageA4Widget/>
          </DragWidget>
        </div>
      </Slider>
    </>
  );
};

export default WidgetCarousel;
